import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { languages } from "./locale";

i18n.use(initReactI18next).init({
  resources: {
    EN: {
      translations:  languages.EN.resources,
    },
    ES: {
      translations: languages.ES.resources,
    },
    UA: {
      translations: languages.UA.resources,
    },
  },
  whitelist: [languages.EN.id],
  fallbackLng: languages.EN.id,
  // debug only when not in production
  debug: false,
  lng:languages.EN.id,
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    formatSeparator: ",",
  },
});
